export const handleZoomState = layoutRef => ({
	zoomed(chartContext, {xaxis}) {
		layoutRef.current.classList.toggle('graph--zoomed', isZoomedRange(chartContext, xaxis))
	},
	updated(chartContext) {
		layoutRef.current.classList.toggle('graph--zoomed', isZoomedRange(chartContext))
	},
})

const isZoomedRange = (chartContext, xaxis) => {
	const {initialMinX, initialMaxX, minX, maxX} = chartContext.w.globals
	const min = xaxis?.min ?? minX
	const max = xaxis?.max ?? maxX
	return min !== initialMinX || max !== initialMaxX
}
